import { Layout, UI } from 'common';
import React, { Component } from 'react';

const { WrappedInputNumberWithLabel } = UI;

class FundAmountCellRenderer extends Component {
	constructor(props) {
		super(props);

		const { node, value } = props;

		const rowHeight = node.rowHeight || 42;

		this.state = {
			// store the default row height for the reset later
			defaultRowHeight: rowHeight,

			value,
		};
	}

	componentDidMount() {
		const { value } = this.state;

		// increase the row height if the fund is invalid
		if (value > 10000) {
			this.this.setState({ rowHeight: 200 });
		}
	}

	// update ag-grid row height on mobile (phone or tablet)
	updateRowHeight = rowHeight => {
		const { isMobile } = this.context;
		const { api, node } = this.props;

		if (isMobile) {
			node.setRowHeight(rowHeight);
			api.onRowHeightChanged();
		}
	};

	// Update the state to re-render WrappedInputNumberWithLabel component.
	// Regarding handling refresh, see
	// https://www.ag-grid.com/javascript-grid-cell-rendering-components/#handling-refresh-2
	refresh = params => {
		const { defaultRowHeight, value } = this.state;

		if (params.value !== value) {
			this.setState(
				{
					value: params.value,
				},
				() => {
					// validate whether fund amount is within the range
					if (params.value > 10000) {
						// change row height to show inline validation error message on mobile (phone or tablet)
						this.updateRowHeight(100);
					} else {
						// reset the row height to normal height on mobile
						this.updateRowHeight(defaultRowHeight);
					}
				}
			);
		}

		return true;
	};

	// set a value directly onto the rowNode, which causes refresh
	// https://www.ag-grid.com/javascript-grid-cell-rendering-components/#events-causing-refresh
	onChange = e => {
		const { value } = e.target;
		const { node } = this.props;

		node.setDataValue('fundAmount', value);
	};

	onBlur = () => {
		const { validate } = this.props;

		// notify the parent to trigger the validation
		if (validate) {
			validate();
		}
	};

	render() {
		const { isMobile } = this.context;
		const {
			data: { custId },
		} = this.props;
		const { value } = this.state;

		return (
			<WrappedInputNumberWithLabel
				className="fund-amount-cell-renderer"
				isInputInvalid={value > 10000}
				errorMessage="Fund Amount cannot exceed $10,000."
				showErrorBelow={isMobile}
				uiElementConfig={{
					name: `${custId}`,
					value,
					showButtons: true,
					mode: 'currency',
					min: 0,
					currency: 'USD',
					onBlur: this.onBlur,
					onChange: this.onChange,
					dataqa: 'fund-amount',
				}}
			/>
		);
	}
}

FundAmountCellRenderer.contextType = Layout.LayoutContext;

export default FundAmountCellRenderer;
